// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./IconButtonTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton-module__Base__QWnEm {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: none;
    user-select: none;
}
/* Sizes */
.IconButton-module__Big__j7wpm {
    padding: var(--ds-sm);
}

.IconButton-module__Medium__EiwAB {
    padding: var(--ds-s);
}

.IconButton-module__Small__t0nN1 {
    padding: var(--ds-xs);
}
/* Rounding */
.IconButton-module__BorderRadius__VlnQC {
    border-radius: var(--ds-border-radius-sm);
}

.IconButton-module__BorderRadiusSmall__uvsxP {
    border-radius: var(--ds-border-radius-s);
}

.IconButton-module__Loading__Qsn62 {
    color: var(--ds-icon-button-loading-icon-color);
    background-color: var(--ds-icon-button-loading-bg-color);
}
/* Ghost */
/* ------------ */
.IconButton-module__KindGhostEnabled__cJ52y:hover {
    background-color: var(--ds-icon-button-ghost-hover-bg-color);
}
/* Input Like */
/* ------------ */
.IconButton-module__KindInputLikeEnabled__Ix6Yz {
    color: var(--ds-input-like-button-color);
    background-color: var(--ds-input-like-button-bg-color);
    box-shadow: var(--ds-input-like-button-box-shadow);
}

.IconButton-module__KindInputLikeEnabled__Ix6Yz:focus-visible {
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: var(--ds-05x);
}

.IconButton-module__KindInputLikeEnabled__Ix6Yz:hover {
    color: var(--ds-input-like-button-hover-color);
    background-color: var(--ds-input-like-button-hover-bg-color);
    box-shadow: var(--ds-input-like-button-hover-box-shadow);
}

.IconButton-module__KindInputLikeDisabled__xi__P {
    color: var(--ds-input-like-button-disabled-color);
    background-color: var(--ds-input-like-button-disabled-bg-color);
    box-shadow: none;
}

.IconButton-module__KindInputLikeLoading__RyUyr {
    background-color: var(--ds-input-like-button-loading-bg-color);
    box-shadow: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Base": `IconButton-module__Base__QWnEm`,
	"Big": `IconButton-module__Big__j7wpm`,
	"Medium": `IconButton-module__Medium__EiwAB`,
	"Small": `IconButton-module__Small__t0nN1`,
	"BorderRadius": `IconButton-module__BorderRadius__VlnQC`,
	"BorderRadiusSmall": `IconButton-module__BorderRadiusSmall__uvsxP`,
	"Loading": `IconButton-module__Loading__Qsn62`,
	"KindGhostEnabled": `IconButton-module__KindGhostEnabled__cJ52y`,
	"KindInputLikeEnabled": `IconButton-module__KindInputLikeEnabled__Ix6Yz`,
	"KindInputLikeDisabled": `IconButton-module__KindInputLikeDisabled__xi__P`,
	"KindInputLikeLoading": `IconButton-module__KindInputLikeLoading__RyUyr`
};
export default ___CSS_LOADER_EXPORT___;
